import moment from 'moment'
import { localeSpecifications } from '@src/util/constants'

export function convertToYYYYMMDD (value: string | number | Date): string {
  if (typeof value === 'string') {
    let selectedLocale = moment.locale()
    const spec = localeSpecifications[selectedLocale] || localeSpecifications['en']
    return moment(value, spec.longDateFormat.L).locale('en').format('YYYY-MM-DD')
  } else if (typeof value === 'number') {
    return moment(new Date(value)).locale('en').format('YYYY-MM-DD')
  } else {
    return moment(value).locale('en').format('YYYY-MM-DD')
  }
}

export function convertToLocalDate (value: string | Date) {
  let selectedLocale = moment.locale()
  const spec = localeSpecifications[selectedLocale] || localeSpecifications['en']
  return moment(value).locale('en').format(spec.longDateFormat.L)
}

export function getLocaleFormat () {
  let selectedLocale = moment.locale()
  const spec = localeSpecifications[selectedLocale] || localeSpecifications['en']
  return spec.longDateFormat.L
}

export function convertLocalDateToDate (value: string): Date {
  let selectedLocale = moment.locale()
  const spec = localeSpecifications[selectedLocale] || localeSpecifications['en']
  return moment(value, spec.longDateFormat.L).toDate()
}

export function convertYYYYMMDDToDate (value: string): Date {
  return moment(value, 'YYYY-MM-DD').toDate()
}

export function convertDateTo (value: string | Date | number, format: string): string {
  return moment(value).format(format)
}

export function convertWeekDay (value: string, format: string): string {
  // convert from English name to number of the day in week (0 - 6)
  let weekDay = moment(value, 'dddd', 'en').format('d')

  return moment(weekDay, 'd').format(format)
}

export function convertMonth (value: string, format: string): string {
  // convert from English name to number of the day in week (0 - 11)
  let month = moment(value, 'MMMM', 'en').format('M')

  return moment(month, 'M').format(format)
}

export function getLocalDateFormat (locale: string): string {
  switch (true) {
    case locale.includes('de'):
      return 'dd.MM.yyyy'
    case locale.includes('fi'):
      return 'dd.MM.yyyy'
    case locale.includes('tr'):
      return 'dd.MM.yyyy'
    case locale.includes('ja'):
      return 'yyyy/MM/dd'
    case locale.includes('ar'):
      return 'dd/MM/yyyy'
    default:
      return 'dd/MM/yyyy'
  }
}

export function getChartLocalDateFormat (locale: string): string {
  switch (true) {
    case locale.includes('de'):
      return '%d.%m.%Y'
    case locale.includes('fi'):
      return '%d.%m.%Y'
    case locale.includes('tr'):
      return '%d.%m.%Y'
    case locale.includes('ja'):
      return '%Y/%m/%d'
    default:
      return '%d/%m/%Y'
  }
}

export function calcDateDifference (start , end): number {
  let startDate = moment(convertToYYYYMMDD(start))
  let endDate = moment(convertToYYYYMMDD(end))
  return endDate.diff(startDate,'days')
}
